import { writable } from 'svelte/store';
import { browser } from '$app/environment';

export const theme = writable(browser && window.__theme);

if (browser && window.matchMedia) {
	const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
	mediaQuery.addEventListener('change', (event) => {
		const newTheme = event.matches ? 'dark' : 'light';
		theme.set(newTheme);
		document.documentElement.setAttribute('data-theme', newTheme);
		window.__theme = newTheme;
	});
}
